<app-page heading="Your Packs">
  @if (roleService.canEdit()) {
    <ng-template pageHeadingButtons>
      <app-button type="new_pack" [routerLink]="['new']"/>
    </ng-template>
  }

  <div class="scroll-container">
    <app-entity-list [items]="packs" linked="true"/>
  </div>
</app-page>
